import { createContext, useContext } from "react";

export const CurrentSsoHintContext = createContext<string | undefined>(
  undefined,
);

export const useCurrentSsoHint = () => useContext(CurrentSsoHintContext);
